import React from 'react';
import ReactDocumentTitle from "../../components/ReactDocumentTitle";
import Logo from '../../components/icon/Logo';
import EmailPasswordForm from '../../components/login/EmailPasswordForm';
import SocialLoginForm from '../../components/login/SocialLoginForm';
import ToastNotification, {showError} from '../../ui/ToastNotification';
import {getQueryParam} from '../../utils';
import {LOGIN_ERROR_SOCIAL_AUTH_FAILED} from '../../backend';
import {useHistory} from 'react-router';
import Promo from '../../components/login/Promo';

export default function LoginScene() {
  const history = useHistory();
  const externalErrorCode = getQueryParam(history, 'err');
  if (externalErrorCode && externalErrorCode === LOGIN_ERROR_SOCIAL_AUTH_FAILED.toString(10)) {
    showError('Your account not found or something else went wrong');
  }

  return (
    <>
      <ReactDocumentTitle title='Login to Workshop Butler'/>
      <div className="min-h-screen h-full bg-gray-light flex flex-col">
        <ToastNotification/>
        <div className="bg-white h-16 w-full py-2">
          <div className="max-w-7xl mx-auto">
            <a href="https://workshopbutler.com">
              <Logo className="ml-3 xl:ml-0"/>
            </a>
          </div>
        </div>
        <div className="md:py-10 h-full">
          <div className="max-w-7xl mx-auto flex h-full">
            <div
              className="flex-1 flex justify-center w-1/2 py-4 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24 bg-white md:rounded-l-lg">
              <div className="mx-auto w-full max-w-sm lg:w-96 my-auto">
                <h2 className="mt-2 text-2xl font-extrabold">Login to Workshop Butler</h2>
                <div className="mt-8">
                  <div className="h-1/2">
                    <div className="mt-6">
                      <EmailPasswordForm/>
                    </div>

                    <div className="mt-6 relative">
                      <div className="absolute inset-0 flex items-center" aria-hidden="true">
                        <div className="w-full border-t border-gray"/>
                      </div>
                      <div className="relative flex justify-center text-sm">
                        <span className="px-2 bg-white text-gray">or</span>
                      </div>
                    </div>
                  </div>
                  <div className="mt-6 h-1/2">
                    <SocialLoginForm/>
                  </div>
                </div>
              </div>
            </div>
            <div className="hidden md:block relative w-0 flex-1 rounded-r-lg">
              <Promo/>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
